import { Site } from "./Site"

export enum CampagneTargetType
{
    SEL = "SEL",
    CRC = "CRC",
    ADV = "ADV",
}

export interface Occurrence
{
    id: number
    business_days_count: number
    date: string
    end_date: string
    status: string
    targets_count: number
    user_targets_count: number
}

export interface Target {
    id: number
    occurrence_id: number
    contact_id: number
    dealership_id: number
    followed_by_user_id: number
    seller_user_id: number
    lead_id: number | null
    action_id: number | null
}

export interface Campagne
{
    actions_targets_count: number
    assigned_targets_count: number
    code: string
    dealerships: Site[]
    description: string
    end_assignment_leads_date?: string | null
    end_date?: string | null
    frequency: string
    goal: string
    id: number
    is_recurring: boolean
    lead_origin_channel_id: number | null
    leads_targets_count: number
    name: string
    occurrences: Occurrence[]
    origin_action_id: number | null
    processed_actions_targets_count: number
    processed_leads_targets_count: number
    processed_targets_count: number
    start_date?: string | null
    status: string
    subject: string
    target_type: CampagneTargetType
    total_targets_count: number
    unassigned_targets_count: number
    type: string
}

export interface TargetDistribution
{
    followed_by: {
        id: number
        name: string
        types: string[]
    },
    followed_by_user_id: number
    selected_targets: number
    solde: number
    targets_count: number
    followed_with_assignment_count: number
    leads_targets_count: number
    processed_leads_targets_count: number
    is_shared_pool?: boolean | null
    assigned_targets_count?: number | null
    // Parmi les cibles suivies par ce commercial (followed_by), combien lui sont aussi assignées
    // (seller_user_id). La différence avec assigned_targets_count donne les cibles assignées hors
    // de son propre quota suivi
    followed_and_assigned_targets_count?: number | null
}

// Entrée de redistribution du solde des contacts non assignés : associe un commercial à la liste
// des IDs de cibles qui lui ont été redistribuées via la modale "Attribuer le solde restant".
export interface RedistributionEntry {
    followed_by: {
        id: number
        name: string
        types: string[]
    }
    target_ids: number[]
}

